import { IBookFromPreviousOrder, IBookStrategy } from '@aca-new/app/pages/book/shared/models/interfaces/book-strategy.interface';
import { IDraft } from '@aca-new/app/pages/book/shared/models/interfaces/draft.interface';
import { BookingFeatureService } from '@aca-new/app/pages/book/shared/services/booking-feature.service';
import { BookFromPreviousOrderService } from '@aca-new/app/pages/bookings/pages/previous-order-item/components/book-from-previous-order/shared/services/book-from-previous-order/book-from-previous-order.service';
import { IPreviousOrderSelect } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/interfaces/book-from-previous-table-strategy.interface';
import { DialogRef } from '@aca-new/app/shared/components/modal/shared/classes/dialog.ref';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { EPostMessageType } from '@aca-new/app/shared/models/enums/post-message-type.enum';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { AppOverlayService } from '@aca-new/app/shared/services/modal-services/app-overlay/app-overlay.service';
import { AcaMessageService } from '@aca-new/app/shared/services/post-message-services/aca-message/aca-message.service';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { QimaOptionalType } from '@qima/ngx-qima';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class InspectionBookStrategyService implements IBookStrategy {
  public constructor(
    private readonly _storageService: StorageService,
    private readonly _injector: Injector,
    private readonly _router: Router,
    private readonly _overlayService: AppOverlayService,
    private readonly _bookFromPreviousOrderService: BookFromPreviousOrderService,
    private readonly _bookingFeatureService: BookingFeatureService
  ) {}

  public getBookFromPreviousUrl(orderId: string, serviceType: string): string {
    const userId: string = this._storageService.getItem(EStorageKeys.USER_ID);

    return `${SERVER_URL}/user/${userId}/draft/previous-psi-order/${orderId}?service-type=${serviceType}`;
  }

  public bookFromPreviousOrder(data: IBookFromPreviousOrder): void {
    if (this._bookingFeatureService.isEnabledMyQimaBookingServiceType(data.serviceType)) {
      if (data.isAcaBookRoute) {
        this._storageService.setItem(EStorageKeys.TARGET_BOOK_PREVIOUS, JSON.stringify(data.previousOrder));
        this._injector.get(AcaMessageService).pathChangeHandler('/home');

        data.dialogRef?.close();
      } else {
        this.createDraftFromPreviousOrder(
          this.getBookFromPreviousUrl(data.previousOrder.originData.orderId, data.serviceType.toLowerCase()),
          data.serviceType.toLowerCase(),
          data.dialogRef
        );
      }
    } else {
      this._injector.get(AcaMessageService).postMessageToAca({
        type: EPostMessageType.BOOK_FROM_PREVIOUS_ORDER,
        data: {
          value: data.previousOrder.originData,
          customServiceType: data.serviceType,
          serviceType: data.previousOrder.originData.serviceTypeText,
        },
      });
    }
  }

  public createDraftFromPreviousOrder(url: string, serviceType: string, dialogRef?: DialogRef<QimaOptionalType<IPreviousOrderSelect>>): void {
    this._overlayService.updateIsLoading(true);
    this._bookFromPreviousOrderService
      .createDraftFromPreviousOrder$(url)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (response: IDraft | null): void => {
          if (!response) {
            return;
          }

          const url = `/book-inspection/${serviceType}/${response.draftId}`;

          void this._router.navigateByUrl('/', { skipLocationChange: true }).then((canLeave: boolean): void => {
            if (canLeave) {
              void this._router.navigateByUrl(url);
            }
          });

          dialogRef?.close();
        },
        complete: (): void => {
          this._overlayService.updateIsLoading(false);
        },
      });
  }
}
